// Shared by the Live API import tab and the scrape-fallback search matcher.
// A bare numeric string is returned as-is; a product URL has its item ID
// extracted from between "/item/" and ".html" (query strings are ignored
// because the match stops at the extension boundary).
const ITEM_ID_WITH_EXTENSION = /\/item\/(\d{10,})\.(?:html?|htm)\b/i;
const ITEM_ID_WITHOUT_EXTENSION = /\/item\/(\d{10,})\b/i;

// Matches only the "/item/<digits>.html" shape — no bare-ID passthrough, no host
// check. Used as-is by the scrape-fallback matcher, which feeds it raw hrefs
// (sometimes relative, with no host to check).
export function matchAliExpressItemUrl(value) {
  const text = String(value || '');
  const match = text.match(ITEM_ID_WITH_EXTENSION) || text.match(ITEM_ID_WITHOUT_EXTENSION);
  return match ? match[1] : '';
}

export function parseAliExpressProductId(rawInput) {
  const value = String(rawInput || '').trim();
  if (!value) return { id: '', ok: false, source: null };
  if (/^\d+$/.test(value)) return { id: value, ok: true, source: 'id' };
  // Only an absolute URL needs a host check; a relative href falls through to
  // the shape match below.
  if (/^https?:\/\//i.test(value)) {
    let hostname = '';
    try {
      hostname = new URL(value).hostname.toLowerCase();
    } catch {
      return { id: '', ok: false, source: null };
    }
    if (!hostname.includes('aliexpress')) return { id: '', ok: false, source: null };
  }
  const id = matchAliExpressItemUrl(value);
  return id ? { id, ok: true, source: 'url' } : { id: '', ok: false, source: null };
}
